export default class Feedback {
  static async retrieve(axios, id) {
    const response = await axios.post('/graphql/', {
      query: `query feedbackRetrieve($id: ID!) {
        feedbackRetrieve(id: $id){
          id
          subject
          content
          dateTime
          state
        }
      }`,
      variables: {
        "id": id
      }
    },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.feedbackRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query{
        feedbackList {
          results {
            id
            subject
            content
            dateTime
            state
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.feedbackList.results.reverse();
  }

  static async filter(axios, init, last) {
    const response = await axios.post(
      '/graphql/',
      `query{
        feedbackList (dateTime_Gte: "${init}", dateTime_Lte: "${last}") {
          results {
            id
            subject
            content
            dateTime
            state
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.feedbackList.results.reverse();
  }

  static async edit(axios, id, state) {

    const response = await axios.post(
      '/graphql/',
      `mutation {
        updateFeedback(newFeedback: {
          id: ${id},
          state: "${state}",
        }) {
          ok
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.updateFeedback.ok;
  }
}